import MojitoCore from 'mojito/core';
import MojitoModules from 'mojito/modules';
import MojitoPresentation from 'mojito/presentation';
import SportCountriesList from 'applications/sports/components/search/search-discovery-view/sport-countries-list/index.js';

const { Button, FlexPane, Image, SportIcon, Text } = MojitoPresentation.Components;
const { dispatch } = MojitoCore.Services.redux.store;
const { IntentActionTrigger } = MojitoPresentation.Base.Intent;
const { NavigationPathBuilder } = MojitoPresentation.Base.Navigation;
const { module: SportGroupsList, types: SportGroupsListTypes } = MojitoModules.SportGroupsList;
const { COUPONS } = MojitoModules.SingleLeagueCoupon.SingleLeagueCouponTypes;
const { actions: sportsMenuActions } = MojitoModules.SportsMenu;

const getFavoriteClass = (sportId, isFavorite) =>
    `ta-sportPanelFavorite ta-${sportId}${isFavorite ? ' ta-selected' : ''}`;

const SportPanelSection = props => {
    const {
        competitionsGroupId,
        expanded,
        isFavoriteSport,
        onNavigate,
        onToggle,
        sport,
        mojitoTools: { appContext, config, stringResolver, style },
    } = props;
    const { routeResolver, subscriptionResolver } = appContext;
    const allOfferText = stringResolver.resolveString('$SEARCH_DISCOVERY_VIEW.SPORT_ALL_OFFER');
    const favoriteIcon = isFavoriteSport ? style.favoriteIconToggled : config.favoriteIcon;

    const onAllOfferClick = () => {
        IntentActionTrigger.showSport(sport.id);
        onNavigate();
    };

    const onFavoriteClick = () => {
        dispatch(sportsMenuActions.toggleFavoriteSport(sport.id));
    };

    // The header is a plain container, not a button, so the favorite and expand controls are not
    // nested interactive elements (which are invalid and break keyboard/screen-reader usage).
    return (
        <FlexPane config={config.container} class="ta-sportPanelSection">
            <FlexPane config={config.sportHeader} class="ta-sportPanelHeader">
                <Button
                    config={config.sportToggle}
                    onClick={onToggle}
                    active={expanded}
                    class="ta-sportPanelHeaderToggle"
                >
                    <FlexPane config={config.sportIdentity}>
                        <SportIcon sportId={sport.id} config={config.sportIcon} alt={sport.name} />
                        <Text config={config.sportName}>{sport.name}</Text>
                    </FlexPane>
                </Button>
                <FlexPane config={config.headerActions}>
                    {config.showFavorites && (
                        <Button
                            config={config.favoriteButton}
                            onClick={onFavoriteClick}
                            class={getFavoriteClass(sport.id, isFavoriteSport)}
                        >
                            <Image config={favoriteIcon} />
                        </Button>
                    )}
                    <Button
                        config={config.expandToggle}
                        onClick={onToggle}
                        active={expanded}
                        class="ta-sportPanelHeaderExpand"
                    >
                        <Image config={expanded ? style.collapseIcon : config.expandIcon} />
                    </Button>
                </FlexPane>
            </FlexPane>
            {expanded && (
                <FlexPane config={config.contents} class="ta-sportPanelSectionContents">
                    <Button
                        config={config.allOfferButton}
                        onClick={onAllOfferClick}
                        hrefLink={routeResolver.getRoute(NavigationPathBuilder.toSport(sport.id))}
                        class="ta-sportPanelAllOffer"
                    >
                        <SportIcon config={config.allOfferIcon} alt={allOfferText} />
                        <Text config={config.allOfferText}>{allOfferText}</Text>
                    </Button>
                    {config.showTopLeagues && (
                        <SportGroupsList
                            class="ta-sportPanelTopCompetitions"
                            config={config.topCompetitions}
                            sportId={sport.id}
                            type={SportGroupsListTypes.TYPE.TOP}
                            groupId={subscriptionResolver.topLeagues(sport.id)}
                            pageType={COUPONS.COMPETITIONS}
                            onItemClick={onNavigate}
                        />
                    )}
                    {config.showCountries && (
                        <SportCountriesList
                            config={config.countriesList}
                            sportId={sport.id}
                            groupId={competitionsGroupId}
                            onNavigate={onNavigate}
                        />
                    )}
                </FlexPane>
            )}
        </FlexPane>
    );
};

// Merge the toggled/collapse variants over their base icon so DBX overrides only the differences.
SportPanelSection.getStyle = (config, mode, merge) => ({
    favoriteIconToggled: merge(config.favoriteIcon, config.favoriteIconToggled),
    collapseIcon: merge(config.expandIcon, config.collapseIcon),
});

export default SportPanelSection;
